import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NowProvider {

  public now(): Date {
    return new Date();
  }

}
